if (!customElements.get('card-variant-select')) {
  customElements.define(
    'card-variant-select',
    class CardVariantSelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.panels = Array.from(this.querySelectorAll('[data-variant-id]'));
        if (!this.select) return;
        this.select.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        const selectedId = this.select.value;
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.variantId !== selectedId;
        });
      }
    }
  );
}
